<template>
  <vx-card>
    <validation-observer ref="validator" #default="{valid}">
      <b-form
        :class="[inline ? 'gap-2 items-center' : '']"
        :inline="inline"
        @submit.prevent="addDestination"
        @reset.prevent="clearForm"
        @reset="onReset">

        <validation-provider
          #default="validationContext"
          :name="$t('newsletter.workflow.destination_name')"
          rules="required"
          class="flex-grow"
          slim>
          <b-form-group
            id="input-group-1"
            :label="$t('newsletter.workflow.destination_name')"
            label-for="newsletter_workflow_destination_name">
            <b-form-input
              id="newsletter_workflow_destination_name"
              v-model="destination.name"
              :placeholder="$t('newsletter.workflow.destination_name')"
              class="required">
            </b-form-input>
            <b-form-invalid-feedback :class="[{'absolute': inline}]">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>
        <!-- E-mail-->
        <validation-provider
          #default="validationContext"
          :name="$t('newsletter.workflow.destination_email')"
          rules="required|email"
          class="flex-grow"
          slim>
          <b-form-group
            id="input-group-1"
            :label="$t('newsletter.workflow.destination_email')"
            label-for="newsletter_workflow_destination_email">
            <b-form-input
              id="newsletter_workflow_destination_email"
              type="email"
              v-model="destination.email"
              :placeholder="$t('newsletter.workflow.destination_email')"
              class="required">
            </b-form-input>
            <b-form-invalid-feedback :class="[{'absolute': inline}]">
              {{ validationContext.errors[0] }}
            </b-form-invalid-feedback>
          </b-form-group>
        </validation-provider>

        <div class="flex flex-row justify-end gap-4">
          <b-button
            v-permission="`newsletter_workflows.edit`"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="px-1"
            variant="outline-primary"
            @click="addDestination"
            :disabled="!valid">
            <feather-icon
              icon="PlusIcon"
              class="mr-50"/>
            <span class="align-middle">{{ $t('add') }}</span>
          </b-button>
           <b-button
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            class="px-1"
            variant="outline-primary"
            @click="$bvModal.show('search-contact')">
            <b-icon-search class="mr-50"/>
            <span class="align-middle">{{ $t('newsletter.workflow.destination_search_contact') }}</span>
          </b-button>
        </div>
      </b-form>
    </validation-observer>

  <div class="vs-row w-full pt-2">
    <grid
        ref="grid-destination"
        v-if="service"
        :hide_actions="false"
        :service="service"
        :route_grid_path="`/${id}/destinations/grid`"
        route_name="newsletter_workflows"
        :column_formats="{
          created_at: (val) => {
            return $utils.format.date(val)
          },
          dispatched_at: (val) => {
            return $utils.format.date(val)
          },
          status : (val) =>{
            return ''+val.label
          }
        }"
        :css_formats="{
          status: (val) => {
           return 'text-'+val.color
          }
        }"
      >
        <template v-slot:actions="actions">
          <!--
          <feather-icon
            v-permission="`newsletter_workflows.edit`"
            v-tooltip="'Enviar ao destinatário'"
            v-if="canDispatchDestination(actions.row)"
            icon="SendIcon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-primary"
            @click="dispatchDestination(actions.row.id)"/>
          -->
          <feather-icon
            v-permission="`newsletter_workflows.edit`"
            v-tooltip="'Remover destinatário'"
            v-if="canDeleteDestination(actions.row)"
            icon="Trash2Icon"
            class="h-5 w-5 mb-1 mr-1 stroke-current text-danger"
            @click="confirmDeleteDestination(actions.row)"/>
        </template>
      </grid>

      <div class="flex flex-row justify-end gap-4">
        <!--
        <b-button v-permission="`newsletter_workflows.edit`"
                  variant="warning"
                  @click="dispatch">
              <feather-icon icon="SendIcon" class="mr-50"/>
                  {{ $t('action.send_pending') }}
        </b-button>
        -->
        <b-button @click="goBack" variant="outline-secondary">Voltar</b-button>
      </div>
      <!-- Pop contact-->
      <calendar-contact-popup @selected="addContactList"/>
  </div>
  </vx-card>
</template>

<script>

import SelectSuggestion from '@/components/SelectSuggestion.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, min, email } from '@validations'
import standard from '@/services/standard'
import { debounce } from 'lodash'


import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BFormTextarea,
  BButton,
  BIconLink45deg,
  BIconClipboard,
  BIconCheck,
  BIconX,
  BIconExclamationTriangle,
  BIconSearch,
  BFormInvalidFeedback,
  VBTooltip,
} from 'bootstrap-vue'

import  NewsletterWorkflowService from '@/services/api/NewsletterWorkflowService'
import CalendarContactPopup from '../../calendar/calendar-event-handler/CalendarContactPopup.vue'

export default {
   directives: {
    'b-tooltip': VBTooltip,
  },
  components: {
    SelectSuggestion,
    BForm,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BFormTextarea,
    BButton,
    BIconLink45deg,
    BIconClipboard,
    BIconCheck,
    BIconX,
    BIconExclamationTriangle,
    BIconSearch,
    ValidationObserver,
    ValidationProvider,
    BFormInvalidFeedback,
    CalendarContactPopup,
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: () => ({
    destination: {
      name: '',
      email: ''
    },
    service: null,
    required, email, min
  }),
  beforeMount() {
    this.updateGrid()

    //this.$root.$on('missive-dispatched', this.updateGrid)
  },
  beforeDestroy() {
    //this.$root.$off('missive-dispatched', this.updateGrid)
  },
  methods: {
    updateGrid(){
      const grid = this.$refs['grid-destination']
      if (grid) {
       grid.fetchGridData()
      }
    },
    goBack() {
      this.$router.push({
        name: 'newsletter-workflow-index'
      })
    },
    addContactList(contactList = null){
      if (contactList && this._.isArray(contactList) && contactList.length > 0) {
        let destinations = []

        contactList.forEach(
            (contact) => destinations.push({name: contact.name, email: contact.email})
        )

        this.addWorkflowDestination(destinations)
      }
    },
    addDestination() {
      const destinations = [this.destination]

      this.addWorkflowDestination(destinations)
    },

    addWorkflowDestination(destinations) {
      this.$vs.loading()
      if (this.id) {
        this.service.addDestination(this.id, destinations).then(
          response => {
            this.notifySuccess(this.$vs, this.$t('messages.success'))
            this.canDispatch()
            this.clearForm()
          },
          error => {
            this.notifyError(this.$vs, `Não foi possível adicionar o(s) destinatário(s)!`)
          }
        ).finally(
          () => {
            this.$vs.loading.close()
            this.updateGrid()
          }
        )
      }
    },
    clearForm(){
      this.destination.name = ''
      this.destination.email = ''
    },
    confirmDeleteDestination(item) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        acceptText: this.$t('action.yes'),
        cancelText: this.$t('action.no'),
        title: this.$t('action.remove'),
        text: this.$t('messages.confirm_deletion')+` ${item.name}`,
        accept: () => {
          this.deleteDestination(item)
        }
      })
    },
    deleteDestination(entity) {
      this.$vs.loading()
      this.service.deleteDestination(this.id, entity.id).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.updateGrid()
        },
        error => {
          this.notifyWarning(this.$vs, this.$t('messages.error'))
        }
      ).finally(
          () => {
            this.$vs.loading.close()

          }
        )
    },
    dispatchDestination(id) {
      console.log('To dispatch destination', id)
      this.$vs.loading()
      this.service.dispatchDestination(this.id, id).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('messages.success'))
          this.updateGrid()
        },
        error => {
          this.notifyWarning(this.$vs, this.$t('messages.error'))
          this.updateGrid()
        }
      ).finally(
        () => this.$vs.loading.close()
      )
    },

    canDispatchDestination(destination) {
      return true
    },
    canDeleteDestination(destination) {
      return true
      const onError = destination.status === 'ER'
      const onUk = destination.status === 'UK'
      const onPending = destination.status === 'PD'

      return onError || onUk ||onPending
    },
    canDispatch() {
      const grid = this.$refs['grid-destination']
      if(grid){
        const data = grid.model ? grid.model.data : null;
        if(data && data.length > 0){
          const destination = data[0]
          const count = destination.pending_dispatches_count
          return count > 0
        }
        return false
      }
      return false
    },
    dispatch() {
      if (!this.canDispatch()) {
        this.notifyWarning(this.$vs, "Não há envio pendentes para esse(s) informativo(s).")
        return
      }

      this.$vs.loading()
      this.service.dispatch(this.id).then(
        response => {
          this.notifySuccess(this.$vs, this.$t('newsletter.workflow.messages.envio_pendente_disparado'), 9000)
          this.updateGrid();
        },
        error => {
          this.notifyWarning(this.$vs, this.$t('messages.error'))
        }
      ).finally(
        () => {
          this.$vs.loading.close()
        }
      )
    },

  },
  computed: {
    validateDestinationForm(){
      return (
        !this.isEmpty(this.destination.name) &&
        !this.isEmpty(this.destination.email))
    }
  },
  beforeMount() {
    this.service = NewsletterWorkflowService.build(this.$vs)
  },
}
</script>


<style lang="scss" scoped>
  ::v-deep .vs-popup {
    width: 800px !important;
  }
</style>
